import { motion, useInView } from 'motion/react';
import { useRef } from 'react';
import Link from 'next/link';
import { Check } from 'lucide-react';

// From identio.fi/en/work/ "Our Services"
const SERVICES = [
  'Software development',
  'Software architecture',
  'Software design',
  'UX and UI design',
  'User research',
];

export function WorkServicesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section ref={ref} className="section-rhythm bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="heading-2 mb-8 text-gray-900 text-center"
        >
          Our Services
        </motion.h2>
        <motion.ul
          initial={{ opacity: 0, y: 16 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-3 list-none p-0 m-0"
        >
          {SERVICES.map((service, index) => (
            <motion.li
              key={service}
              initial={{ opacity: 0, x: -8 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.4, delay: 0.15 + index * 0.05 }}
              className="flex items-center gap-3 text-lg text-gray-700"
            >
              <Check className="w-5 h-5 shrink-0 text-brand" />
              <span>{service}</span>
            </motion.li>
          ))}
        </motion.ul>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center mt-10"
        >
          <Link
            href="/services"
            className="inline-flex items-center gap-2 text-brand font-semibold hover:text-brand-hover transition-colors"
          >
            Learn more about our services
            <span aria-hidden>→</span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
